import React from 'react';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { USER_MESSAGE } from '../../../actions/User';
import useFetchQLpStatsForDownload from '../../Hooks/qlp_ddpcr/useFetchQlpStatsDownload';

const QlpFileDownload = () => {

    const { plate_uuid } = useParams();
    const dispatch = useDispatch();
    const qlpData = useFetchQLpStatsForDownload(plate_uuid);

    const handleDownload = () => {
        if (qlpData?.isSuccess && qlpData?.data) {
            // window.location.href = "http://site6000.global.bio-rad.com/plate/download/112515?analysis_group_id=&amp;reprocess_config_id=";
            window.location.href = qlpData?.data; // this will point to the url and browser will download the file
        }
        if (qlpData?.error) {
            dispatch({
                type: USER_MESSAGE,
                msgType: "error",
                text: "Download was not successful, pls try again",
                key: crypto.randomUUID()
            });
        }
    }

    return (
        <div className='flex-1'>
            <span />
            <button onClick={handleDownload} disabled={qlpData?.isError || qlpData?.isLoading}
                title={qlpData?.isLoading ? "Loading data..." : qlpData?.isSuccess ? "Download QLP" : "Error in fetching.."}
                className={`ml-4 md:ml-8 lg:ml-20 text-[11px] font-extrabold text-center border border-custom-green rounded-[8px] bg-custom-green
                 text-white px-2 py-1 h-10 flex items-center justify-center 
                  ${qlpData?.isError || qlpData?.isLoading ? 'bg-gray-400 border-gray-400 text-gray-200 cursor-not-allowed'
                        : 'bg-custom-green border-custom-green text-white'}`}>
                <CloudDownloadIcon fontSize="small" />  Qlp
            </button>
        </div>
    );
}

export default QlpFileDownload;